var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.5 2.925C4.92624 2.925 5.33502 3.0962 5.63642 3.40095C5.93782 3.7057 6.10714 4.11902 6.10714 4.55C6.10714 4.7634 6.06557 4.97471 5.98481 5.17186C5.90404 5.36901 5.78566 5.54815 5.63642 5.69905C5.48718 5.84994 5.31001 5.96964 5.11503 6.0513C4.92004 6.13297 4.71105 6.175 4.5 6.175C4.07376 6.175 3.66498 6.00379 3.36358 5.69905C3.06218 5.3943 2.89286 4.98098 2.89286 4.55C2.89286 4.11902 3.06218 3.7057 3.36358 3.40095C3.66498 3.0962 4.07376 2.925 4.5 2.925ZM4.5 0C5.69347 0 6.83807 0.479374 7.68198 1.33266C8.52589 2.18595 9 3.34327 9 4.55C9 7.9625 4.5 13 4.5 13C4.5 13 0 7.9625 0 4.55C0 3.34327 0.474106 2.18595 1.31802 1.33266C2.16193 0.479374 3.30653 0 4.5 0ZM4.5 1.3C3.64752 1.3 2.82995 1.64241 2.22716 2.2519C1.62436 2.8614 1.28571 3.68805 1.28571 4.55C1.28571 5.2 1.28571 6.5 4.5 10.8615C7.71429 6.5 7.71429 5.2 7.71429 4.55C7.71429 3.68805 7.37564 2.8614 6.77284 2.2519C6.17005 1.64241 5.35248 1.3 4.5 1.3Z",
    fill: "#D98200"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.83d86d8cdbf7245161dceaac19d20cd5.svg";
export { ForwardRef as ReactComponent };